if (!window.customElements.get("component-media-slider")) {
  class ProductsmainSlider extends HTMLElement {

    constructor() {
      super();

      this.selectors = {
        swiper: "swiper-container",
        prevEl: ".custom-prev-button",
        nextEl: ".custom-next-button"
      }

      this.slider = this.querySelector(this.selectors.swiper);
      this.buttonPrev = this.querySelector(this.selectors.prevEl);
      this.buttonNext = this.querySelector(this.selectors.nextEl);
      this.initSlider();
    }

    initSlider() {
      if (!this.slider) return;

      const navigation = this.buttonPrev && this.buttonNext ? {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev
      } : undefined;

      const swiperParams = {
        slidesPerView: "auto",
        direction: "vertical",
        spaceBetween: 8,
        breakpoints: {
          640: {
            slidesPerView: 1,
          },
          990: {
            slidesPerView: 8,
          }
        },
        navigation,
      };

      customElements.whenDefined('swiper-container').then(() => {
        Object.assign(this.slider, swiperParams);

        this.slider.initialize();

        requestAnimationFrame(() => this.updateArrowsVisibility());
      });
    }

    updateArrowsVisibility() {
      if (!this.slider) return;

      const slidesCount = this.slider.querySelectorAll('swiper-slide').length;
      if (slidesCount > 8) {
        this.classList.remove('hide-thumb-arrows');
      } else {
        this.classList.add('hide-thumb-arrows');
      }
    }
}

customElements.define('component-thumb-slider', ProductsmainSlider);

class ProductsmainSlider2 extends HTMLElement {

  constructor() {
    super();

    this.selectors = {
      swiper: "swiper-container",
      prevEl: ".custom-prev-button",
      nextEl: ".custom-next-button"
    }

    this.slider = this.querySelector(this.selectors.swiper);
    this.buttonPrev = this.querySelector(this.selectors.prevEl);
    this.buttonNext = this.querySelector(this.selectors.nextEl);
    this.initSlider();
  }

  initSlider() {
    if (!this.slider) return;

    const navigation = this.buttonPrev && this.buttonNext ? {
      nextEl: this.buttonNext,
      prevEl: this.buttonPrev
    } : undefined;

    const mainSwiperEl = this.slider;

    const galleryRoot = this.closest('media-gallery') || this.parentElement || this;
    const thumbsEl = galleryRoot.querySelector('component-thumb-slider swiper-container');

      const swiperParams = {
        slidesPerView: "auto",
        spaceBetween: 0,
      thumbs: {
        swiper: thumbsEl || '.swipper__thumb',
      },
      pagination: {
        type: "fraction",
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        990: {
          slidesPerView: 1,
        }
      },
      navigation,
      on: {
        init(swiper) {
          if (swiper.slides.length <= 1) swiper.pagination.el?.remove();

          const initialMediaId = mainSwiperEl.closest('media-gallery')?.dataset.initialMediaId;
          if (!initialMediaId) return;

          const slideIndex = [...mainSwiperEl.querySelectorAll('swiper-slide')].findIndex(
            (slide) => slide.dataset.mediaId === initialMediaId
          );
          if (slideIndex >= 0) swiper.slideTo(slideIndex, 0);
        }
      },
    };

    customElements.whenDefined('swiper-container').then(() => {
      Object.assign(this.slider, swiperParams);

      this.slider.initialize();
    });
  }
}

customElements.define('component-media-slider', ProductsmainSlider2);
}
